<style lang="scss"></style>

<template>
  <div class="add-app-modal">
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(addKeyword)">

        <section class="mb-2">
          <validation-provider
            v-slot="validationContext"
            name="Keyword or phrase"
            :rules="{ required: true, min: 3 }"
          >
            <div class="mb-1">
              <label>Keyword or Phrase</label>
              <b-form-input
                v-model.trim="keyword.keyword" cy="keyword-name-input"
                :state="getValidationState(validationContext)"
                placeholder="Enter keyword or phrase"
              />
              <b-form-invalid-feedback>
                Keyword or phrase must be at least 3 letters long
              </b-form-invalid-feedback>
            </div>
          </validation-provider>

          <validation-provider
            v-slot="validationContext"
            name="Keyword type"
            :rules="{ required:true }"
          >
            <div class="mb-1">
              <label>Keyword Type</label>
              <span id="keyword-type" style="padding-left: 0.25rem">
                <feather-icon
                  icon="InfoIcon"
                  size="16"
                />
              </span>
              <b-tooltip
                triggers="hover"
                target="keyword-type"
              >
                <p>
                  <b>Global:</b> These keywords apply to all post in the establishment and will trigger alerts no matter who the post is for.
                  <br>
                  <br>
                  <b>Specific:</b> These keywords are tied to an individual. Alerts will only be triggered when these keywords appear in post for that specific resident.
                </p>
              </b-tooltip>
              <b-form-select
                v-model="keyword.keywordType"
                cy="keyword-type-select"
                :state="getValidationState(validationContext)"
              >
                <b-form-select-option value="Global">Global</b-form-select-option>
                <b-form-select-option value="Specific">Specific</b-form-select-option>
              </b-form-select>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </div>
          </validation-provider>

          <div v-if="keyword.keywordType === 'Specific'" class="mb-1">
            <validation-provider
              v-slot="validationContext"
              :name="$options.filters.term('prisoner') + ' number'"
              :rules="{required: true, prisonerNumberFormat: true}"
            >
              <label>{{ $options.filters.term('prisoner', true) }} Number</label>
              <b-form-input
                v-model.trim="keyword.prisoner_number" cy="keyword-add-prisoner-no"
                :state="getValidationState(validationContext)"
                :placeholder="'Enter ' + $options.filters.term('prisoner') + ' number'"
              />
              <b-form-invalid-feedback v-if="validationContext.errors[0]">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </div>

          <validation-provider
            v-slot="validationContext"
            name="Match type"
            :rules="{ required:true }"
          >
            <label>Match Type</label>
            <span id="match-type" style="padding-left: 0.25rem">
              <feather-icon
                icon="InfoIcon"
                size="16"
              />
            </span>
            <b-tooltip
              triggers="hover"
              target="match-type"
            >
              <p>
                <b>Exact Match:</b> Triggers only when the exact word or phrase is found. <b>Example:</b> If the keyword is <b>"apple"</b>, it will only trigger if the word <b>"apple"</b> appears exactly, not for <b>"apples"</b> or <b>"pineapple"</b>.
                <br>
                <br>
                <b>Partial Match:</b> Triggers when part of the word or phrase appears. <b>Example:</b> If the keyword is <b>"apple"</b>, it will also trigger for <b>"apples"</b>, <b>"pineapple"</b>, or <b>"apple pie"</b>.
              </p>
            </b-tooltip>
            <b-form-select
              v-model="keyword.match_type"
              cy="keyword-type-select"
              :state="getValidationState(validationContext)"
              class="mb-2"
            >
              <b-form-select-option value="exact">Exact</b-form-select-option>
              <b-form-select-option value="partial">Partial</b-form-select-option>
            </b-form-select>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </validation-provider>
        </section>

        <section class="d-inline-flex full-width mt-2">
          <div class="ui-spacer" />
          <b-button class="mr-2" @click="$emit('close', true)">Cancel</b-button>
          <b-button cy="keyword-add-md" type="submit" variant="primary">Add Keyword</b-button>
        </section>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { BTooltip } from 'bootstrap-vue';
import KeywordsService from '../../../services/KeywordsService'

export default {
  components: { BTooltip },
  props: {},
  data() {
    return {
      keyword: {
        keyword: '',
        keywordType: 'Global',
        prisoner_number: '',
        match_type: 'exact',
      },
    }
  },
  mounted() {
  },
  methods: {
    addKeyword() {
      KeywordsService.createKeyword(this.keyword)
        .then(() => {
          this.$toast.success(`Added keyword ${this.keyword.keyword} Successfully`, {
            toastClassName: ['toast-std', 'success-toast'],
          })

          this.$emit('refresh', true)
        })
        .catch(err => {
          console.log('error adding keyword', err)
          this.$toast.error('Could not add keyword, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          })
        })
    },
    getValidationState({
      dirty,
      validated,
      valid = null,
    }) {
      return dirty || validated ? valid : null
    },
  },
}
</script>
